<template>
  <div id="loginContainer">
    <div class="columns">
      <div class="column"/>
      <div class="column is-half">

        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Login
            </p>
          </header>
          <div class="card-content">
            <form @submit.prevent="login">
              <b-field label="Username">
                <b-input
                  v-model="username"
                  icon="account"
                  autofocus />
              </b-field>
              <b-field label="Password">
                <b-input
                  v-model="password"
                  type="password"
                  icon="key" />
              </b-field>
              <div class="field is-grouped">
                <div class="control">
                  <button
                    :class="'button is-link ' + submitButtonClasses"
                    type="submit">Submit</button>
                </div>
                <div class="control">
                  <router-link
                    to="/register"
                    class="button is-light">
                    Register
                  </router-link>
                </div>
              </div>
            </form>

          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <span>
                If you have trouble logging in, please contact administrator.
              </span>
            </p>
          </footer>
        </div>
      </div>
      <div class="column"/>
    </div>
  </div>
</template>

<script>
import { login, setUser } from '../utils/auth'

export default {
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      submitButtonClasses: ''
    }
  },
  methods: {
    login: function() {
      let self = this
      self.submitButtonClasses = 'is-loading'
      login(this.username, this.password).then(function(data) {
        if (data !== undefined && data !== '') {
          setUser(data)
          self.$router.push('/')
        } else {
          self.username = self.password = ''
          self.$toast.open({
            message: 'Please verify username and passowrd, and try again.',
            duration: 3000,
            position: 'is-top',
            type: 'is-danger'
          })
        }
      }).finally(function() {
        self.submitButtonClasses = ''
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#loginContainer {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue